import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {useEffect, useRef, useState} from "react";
import {get, isEmpty} from "lodash-es";
import {message} from "antd";
import {
  getSeatIpConfigList,
  lineAllocationSave,
  lineAllocationUpdate,
  seatAccountSave,
  seatAccountUpdate
} from "@/services/crmTool.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {getUser} from "shj-utils";
import {getChildrenDicts} from "@/services";

interface IAddOrEditProps {
  open?: boolean
  title?: string
  reload?: (values?: object, res?: any) => void
  onClose?: (values?: object) => void
  setOpen?: (open: boolean) => void
  onReload?: (values?: object) => void
  seatPerson?: any[]
  record?: any
}

export const AddOrEdit: React.FC<IAddOrEditProps> = (props: IAddOrEditProps) => {
  const { record, open, setOpen, onReload } = props
  const formRef = useRef<any>()
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    formRef.current?.onFormRef().resetFields()
    if (!isEmpty(record)) {
      formRef.current?.onFormRef()?.setFieldsValue(record)
    }
  }, [record]);

  const getOptions = async () => {
    const seatConfigList = await getSeatIpConfigList();
    const orgList = await httpOrgList();
    const brandEnum = await getEnums('crm-tools', 'com.shj.saas.crm.tools.enums.seat.BrandEnum');
    const zhiTongLine = await getChildrenDicts(['zitongLine']);
    return Promise.resolve({ seatConfigList, orgList, brandEnum, zhiTongLine: get(zhiTongLine, '[0].children') })
  }

  const onSubmit = () => {
    formRef.current?.onFormRef().validateFields().then(values => {
      setBtnLoading(true)
      const apiUrl = values.id ? lineAllocationUpdate : lineAllocationSave
      apiUrl(values).then((res: any) => {
        message.success(res.message || '操作成功');
        setOpen?.(false)
        onReload?.()
      }).finally(() => {
        setBtnLoading(false)
      })
    })
  }

  return (
    <SDrawerOrModal
        mode="modal"
        title={(record.id ? '编辑' : '新增')}
        open={open}
        onClose={() => setOpen?.(false)}
        onCancel={() => setOpen?.(false)}
        loading={btnLoading}
        onOk={onSubmit}
        width={500}
    >
      <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        layout={'vertical'}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '外呼服务商',
                name: 'brand',
                required: true,
                rules: [{ required: true, message: '外呼服务商不能为空' }],
                spanCol: 24,
                type: 'select',
                data: 'brandEnum',
                comConfig: {
                  fieldNames: { label: 'description', value: 'key' },
                }
              },
              {
                label: '分公司',
                name: 'orgId',
                required: true,
                rules: [{ required: true, message: '分公司不能为空' }],
                spanCol: 24,
                type: 'select',
                data: 'orgList',
                comConfig: {
                  fieldNames: { label: 'name', value: 'id' },
                }
              },
              {
                label: '线路',
                name: 'line',
                isDeps: true,
                deps: (form) => form.getFieldValue('brand') === 'ZITONG',
                required: true,
                rules: [{ required: true, message: '线路不能为空' }],
                spanCol: 24, type: 'select',
                data: 'zhiTongLine',
                comConfig: {
                  fieldNames: { label: 'name', value: 'dataValue'}
                }
              },

            ],
          },
        ]}
      />
    </SDrawerOrModal>
  )
}